export default __webpack_public_path__ + "static/media/logo_favicon_bmw.dd5d56b8.svg";